import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../services/api";
import type { NavbarResponse } from "../types/homepage";

/**
 * Hook para obtener solo los datos del navbar
 * 
 * USO:
 * - En el Header/Navbar para mostrar el menú de navegación
 * - Se cachea automáticamente por React Query
 * - El backend también cachea en Redis
 * 
 * @returns {NavbarResponse} Estructura jerárquica de catálogos y categorías
 */
export function useNavbar() {
  return useQuery<NavbarResponse>({
    queryKey: ["navbar"],
    queryFn: async () => {
      const response = await apiClient.get<{ success: boolean; data: NavbarResponse }>("/navbar");
      return response.data;
    },
    staleTime: 1000 * 60 * 5, // 5 minutos
    gcTime: 1000 * 60 * 10, // 10 minutos (cacheTime está deprecado en React Query v5)
  });
}

